import { render, staticRenderFns } from "./freshDrugManage.vue?vue&type=template&id=a76121b6&scoped=true&"
import script from "./freshDrugManage.vue?vue&type=script&lang=js&"
export * from "./freshDrugManage.vue?vue&type=script&lang=js&"
import style0 from "./freshDrugManage.vue?vue&type=style&index=0&id=a76121b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76121b6",
  null
  
)

export default component.exports